<button mat-raised-button color="primary"
        [disabled]="noteForm.invalid || noteForm.disabled || spinnerLoading" [class.spinner]="spinnerLoading">
  Adicionar
</button>
